import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollTop = (props) => {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, [pathname]);

  return null;
};

export default ScrollTop;
